import { render, staticRenderFns } from "./CreditCard.vue?vue&type=template&id=56fb8b6c&scoped=true"
import script from "./CreditCard.vue?vue&type=script&lang=js"
export * from "./CreditCard.vue?vue&type=script&lang=js"
import style0 from "./CreditCard.vue?vue&type=style&index=0&id=56fb8b6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fb8b6c",
  null
  
)

export default component.exports